var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-form',{ref:"Form",attrs:{"show-legend":""}},[_c('rkm-row',[_c('rkm-col',[_c('rkm-form-input',{attrs:{"label":"Nome","validations":_vm.validations.nome,"uppercase":""},model:{value:(_vm.model.nome),callback:function ($$v) {_vm.$set(_vm.model, "nome", $$v)},expression:"model.nome"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }